export const number = {
  modal: {
    remove: {
      content: `Are you sure you want to delete the number <b>{number}<b>?`,
      disabled: 'Cannot delete the number used at the entry point or in the SIP account'
    },

    create_internal: {
      input: {
        number: {
          title: 'Phone number'
        }
      }
    }
  },

  list: {
    button: {
      create_internal: 'Add extension number'
    }
  },

  field: {
    number: 'Number',
    type: 'Number type',
    type_use: 'Type of use',
    login: 'Login'
  },

  type: {
    internal: 'Internal | Internal',
    external: 'External | External'
  },

  type_use: {
    use: 'Used',
    not_use: 'Not used'
  }
};
